module.exports = __webpack_public_path__ + "static/img/menuSpis-OFF.365d126a.png";